module.exports = __webpack_public_path__ + "img/Lechner Michael.jpg";